import React, { Component } from "react";
import { compose, withState, withActions } from "containers/HOC";
import { withRouter } from "react-router-dom";
import AnalysisDetails from "./AnalysisDetails";
import { modalInlineClose, modalInlineOpen } from "containers/App/_actions";
import { createDatasetFarm, executeAnalysis } from "./_actions";
import Page from "components/Page";
import PageBody from "components/PageBody";
import * as datasetUtils from "./_utils";

class AnalysisCreate extends Component {
    render() {
        return (
            <Page>
                <PageBody>
                    <AnalysisDetails {...this.props} isNew={true} onSave={(a, b) => this.props.createDatasetFarm(a, b)} executeAnalysis={(a, b, c) => this.props.executeAnalysis(a, b, c)} />
                </PageBody>
            </Page>
        );
    }
}

export default compose(
    withRouter,
    withState((state, ownProps) => {
        const offlineFarm = state.offlineFarms.find((f) => f.id === ownProps.match.params.farmId);
        const farm = offlineFarm
            ? offlineFarm.farm
            : {
                  name: "",
                  address: "",
                  id: ownProps.match.params.farmId,
                  isNew: true,
                  isOwner: "Yes",
                  budgets: [],
                  datasetId: ownProps.match.params.datasetId,
              };
        const offlineBudget = offlineFarm && offlineFarm.farm && offlineFarm.farm.offlineBudgets && offlineFarm.farm.offlineBudgets.find((b) => b.id === ownProps.match.params.budgetId);

        const analysis = datasetUtils.analysisViewModel(
            offlineBudget
                ? offlineBudget.budget
                : {
                      id: ownProps.match.params.budgetId,
                      type: "Scenario",
                      farmId: ownProps.match.params.farmId,
                      hasCompletedBlocks: true,
                      isNew: true,
                      blocks: [datasetUtils.createEmptyBlock("Block 1")],
                  }
        );

        return {
            auth: state.auth,
            online: state.app.online,
            currentDataset: state.dataset.currentDataset,
            datasetId: ownProps.match.params.datasetId,
            refData: state.app.refData,
            smapReferenceResults: state.searchResults.smapReferenceResults,
            farmViewModel: { farm, analysis },
            modelledResults: state.dataset.modelledResults,
        };
    }),
    withActions({ modalInlineClose, modalInlineOpen, createDatasetFarm, executeAnalysis })
)(AnalysisCreate);
